import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ReportModel, SelectedFile } from '../../models/reports';
import { Form, FormArray, UntypedFormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'lib-report-selector',
  templateUrl: './report-selector.component.html',
  styleUrls: ['./report-selector.component.css'],
  standalone: false
})
export class ReportSelectorComponent implements OnInit, OnDestroy {
  @Input()
  public reports: ReportModel[];
  @Output()
  public selectedReports = new EventEmitter<SelectedFile[]>();

  public options: { report: ReportModel; selected: boolean }[];

  selectAll = false;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.options = this.reports.map(report => {
      return { report, selected: false };
    });
  }

  ngOnDestroy(): void {
    //When this accordion closes, it needs to clear all selections.
    this.selectedReports.emit([]);
  }

  public checkboxChanged(value: boolean, name: string) {
    this.options.find(x => x.report.Name === name).selected = value;
    this._updateValue();
    this.selectAll = false;
    if (this.options.filter(x => x.selected).length === this.options.length) {
      this.selectAll = true;
    }
  }

  public selectAllChange(val: boolean) {
    if (this.selectAll) {
      this.selectAll = val;
      this.options.forEach(x => (x.selected = false));
    } else {
      this.selectAll = val;
      this.options.forEach(x => (x.selected = true));
    }
    this._updateValue();
  }

  private _updateValue() {
    const selected = this.options
      .filter(x => x.selected)
      .map(x => {
        return {
          file: x.report.Filename,
          mimeType: x.report.MimeType[0],
          id: x.report.Id
        };
      });
    this.selectedReports.emit(selected);
  }
}
